import { useQuery } from '@tanstack/react-query';
import { fetchDBOrderHistory } from '@/lib/db/DBOrderHistoryHelpers';
import { fetchDBTransferReceipts } from '@/lib/db/DBTransferHistoryHelpers';
export function useOrderHistory({
  orderId,
  cloudWallet,
  solanaAddress,
  tokenAddress,
  includeTransfers = true
}) {
  const query = useQuery({
    queryKey: ['orderHistory', orderId, cloudWallet, tokenAddress, includeTransfers],
    queryFn: async () => {
      const orderHistoryPromise = fetchDBOrderHistory({
        orderId: orderId,
        tokenAddress
      });
      const transferHistoryPromise = fetchDBTransferReceipts({
        fromAddress: cloudWallet,
        toAddress: cloudWallet,
        tokenAddress: tokenAddress ? tokenAddress : null
      });
      const solanaTransferHistoryPromise = fetchDBTransferReceipts({
        fromAddress: solanaAddress,
        toAddress: solanaAddress,
        tokenAddress: tokenAddress ? tokenAddress : null
      });
      const [orderHistory, transferHistory, solanaTransferHistory] = await Promise.all([orderHistoryPromise, includeTransfers ? transferHistoryPromise : Promise.resolve({
        data: []
      }), includeTransfers ? solanaTransferHistoryPromise : Promise.resolve({
        data: []
      })]);
      const orderHistoryData = orderHistory.data || [];
      const transferHistoryData = (transferHistory.data || []).map(transfer => {
        return Object.assign(Object.assign({}, transfer), {
          created_at: new Date(new Date(transfer.created_at).getTime()).toISOString()
        });
      });
      const solanaTransferHistoryData = (solanaTransferHistory.data || []).map(transfer => {
        return Object.assign(Object.assign({}, transfer), {
          created_at: new Date(new Date(transfer.created_at).getTime()).toISOString()
        });
      });
      const mergedHistory = [...orderHistoryData, ...transferHistoryData, ...solanaTransferHistoryData].sort((a, b) => {
        var _a, _b;
        return ((_a = new Date(b === null || b === void 0 ? void 0 : b.created_at)) === null || _a === void 0 ? void 0 : _a.getTime()) - ((_b = new Date(a === null || a === void 0 ? void 0 : a.created_at)) === null || _b === void 0 ? void 0 : _b.getTime());
      });
      return {
        data: mergedHistory
      };
    },
    enabled: orderId || cloudWallet ? true : false
  });
  return query;
}